import React, { useContext, useEffect, useState } from "react";
import productImage from "../../assets/images/discount-one.webp";
import useAxios from "../../services/useAxios.tsx";
import AuthenticationContext from "../Authentication/AuthenticationContext.ts";
import { toast } from "react-hot-toast";

import Container from "../../Components/LogIn/Container";
import { calculateProductPrice } from "../../utils/Helper.ts";
import { removeCommas } from "@persian-tools/persian-tools";
import { isEmpty } from "lodash";

const CardItemContext = React.createContext({
  basketData: "",
  setActiveStep: () => {},
  activeStep: "",
  showOffcanvas: "",
  setShowOffcanvas: () => {},
  changeItemCount: () => {},
  itemCount: 0,
  getItemCountProductPrice: () => {}, //shFazeli 1402/04/26
  submitOrder: () => {}, //shFazeli 1402/04/26
  giftCode: { title: "", value: "-1", max_discount: 0 },
  setGiftCode: () => {},
  description: "",
  setDescription: () => {},
  addressId: "",
  setAddressId: () => {},
  deliveryList: [],
  deliveryChecked: {},
  changeDeliveryType: () => {},
});

export default CardItemContext;

const DELIVERY_PRICE = 50000;

export const CardItemContextProvider = ({ children }) => {
  const { execute: getCartItemsApi } = useAxios("api3/get_cart_items"); //shFazeli 1402/04/25 ادرس api عوض شد
  const { execute: addCartItemsApi } = useAxios("api3/add_cartitem"); //shFazeli 1402/04/25
  const { execute: reduceCartItemsApi } = useAxios("api3/delete_cartitem"); //shFazeli 1402/04/25
  const { execute: addOrderApi } = useAxios("api3/add_order"); //shFazeli 1402/04/28
  const { execute: checkGiftCodeApi } = useAxios("api3/check_giftcode");
  const { execute: getConfigApi } = useAxios("site/get_config");

  const authContext = useContext(AuthenticationContext);
  //دیتای پیشفرض برای سبد خرید
  const [basketData, setBasketData] = useState({
    list: [],
    totalPrice: 0,
    totalDiscount: 0,
    delivery: 0,
    deliveryType: 1,
    // delivery: DELIVERY_PRICE,
  });
  const [giftCode, setGiftCode] = useState({
    title: "",
    value: "-1",
    type: 1,
    max_discount: 0,
  });
  const [description, setDescription] = useState("");
  const [basketListUpdater, setBasketListUpdater] = useState(false); //shFazeli 1402/04/25
  const [itemCount, setItemCount] = useState(0); //shFazeli 1402/04/25
  const [loginShow, setLoginShow] = useState(false); //shFazeli 1402/04/28
  const [loading, setLoading] = useState(false); //shFazeli 1402/04/28
  const [addressId, setAddressId] = useState("");
  const [deliveryList, setDeliveryList] = useState([]);
  const [deliveryChecked, setDeliveryChecked] = useState({});

  /**
   *
   * @param {string add,reduce,remove} type
   */
  const checkGiftCode = (giftCode) => {
    checkGiftCodeApi({ giftCode }).then((res) => {
      switch (res.status) {
        case 1:
          // toast.success("sdf");
          setGiftCode({
            value: res.result.value,
            title: res.result.giftCode,
            type: res.result.type,
            max_discount: res?.result?.max_discount,
          });
          break;
        case -2:
          toast.error("کد وارد شده متعلق به این کاربر نیست");
          break;
        case -3:
          toast.error("تاریخ انقضا کد به اتمام رسیده است");
          break;
        case -4:
          toast.error("کد قبلا استفاده شده است");
          break;

        default:
          toast.error("کد نامعتبر است");
          break;
      }
    });
  };

  const changeItemCount = (type, product_price_id) => {
    if (loading) return;
    setLoading(true);
    let payloadObject = { product_price_id: product_price_id, count: 1 };
    if (type == "add") {
      addCartItemsApi(payloadObject).then((res) => {
        if (res.result == 1) {
          setBasketListUpdater((prev) => !prev);
          toast.success("با موفقیت به سبد خرید اضافه گردید");
        } else if (res.msg && !isEmpty(res.msg)) {
          toast.error(res.msg);
        }
        setLoading(false);
      });
    } else if (type == "reduce") {
      reduceCartItemsApi(payloadObject).then((res) => {
        if (res.result == 1) {
          setBasketListUpdater((prev) => !prev);
          toast.success("سبد خرید با موفقیت ویرایش شد");
        } else if (res.msg != "" && res.msg != undefined) {
          toast.error(res.msg);
        }
        setLoading(false);
      });
    } else if (type == "remove") {
      payloadObject = { ...payloadObject, count: 0 };
      reduceCartItemsApi(payloadObject).then((res) => {
        if (res.result == 1) {
          setBasketListUpdater((prev) => !prev);
          toast.success("با موفقیت از سبد حذف گردید");
        } else {
          toast.error("خطا! در ویرایش سبد خرید");
        }
        setLoading(false);
      });
    }
  }; //hosseini 1402/05/12 تغیر نمایش پیام ها از فرانت
  const getCartItems = async (tempDelivery = 0) => {
    await getCartItemsApi().then((res) => {
      //shFazeli 1402/04/25 start
      let shopList = { list: [], totalPrice: 0, totalDiscount: 0 };
      shopList = {
        list: res?.result ?? [],
        totalPrice: res?.result?.reduce((total, num) => {
          let totalProduct = 0;
          if (num.is_available == 1)
            totalProduct = +num?.main_price * +num?.itemcount;

          return total + totalProduct;
        }, 0),
        totalDiscount: res?.result?.reduce((total, product) => {
          let totalProductDiscount = 0;
          if (product.main_discount != "0") {
            totalProductDiscount =
              +removeCommas(
                calculateProductPrice(product, "discount").leftOver
              ) * +product?.itemcount;
            console.log(
              "discount: ",
              totalProductDiscount,
              calculateProductPrice(product, "discount").leftOver
            );
          }

          return total + totalProductDiscount;
        }, 0),
        delivery: tempDelivery,
        deliveryType: 1,
        // delivery: DELIVERY_PRICE,
      };

      setBasketData(shopList);
      setItemCount(res?.result?.length);
      //shFazeli 1402/04/25 end
    });
  };
  const getItemCountProductPrice = (productPriceId) => {
    let productList = [...basketData.list];
    let productItemCount = productList.filter(
      (v) => v.product_price_id == productPriceId
    );
    if (productItemCount != undefined && productItemCount.length != 0)
      return productItemCount[0]?.itemcount;
    else return 0;
  }; //shFazeli 1402/04/26
  const submitOrder = (data) => {
    let payload = {
      fname: data.fname,
      lname: data.lname,
      address: data.address,
      postalcode: data.zipCode,
      mobile: data.mobile,
      giftCode: giftCode.title,
      ...(giftCode.title != "" && { giftCode: giftCode.title }),

      delivery_price: basketData?.delivery,
      deliveryType: basketData?.deliveryType,
      address_id: 0,
      // address_id: addressId,
      ...(description != "" && { description: description }),
    };
    // if (authContext.isLogged)
    addOrderApi(payload).then((result) => {
      if (result?.status == 1) {
        window.location.href = result?.url;
      } else if (result?.msg != "" && result?.msg != undefined)
        toast.error(result.msg);
    });
    // else setLoginShow(true);
  };
  const changeDeliveryType = (data) => {
    setDeliveryChecked(data);
    setBasketData((prev) => ({
      ...prev,
      delivery: data?.price,
      deliveryType: data?.value,
    }));
  };

  useEffect(() => {
    async function loadPage(params) {
      let tempDelivery = 0;

      await getConfigApi({ config_name: "delivery" }).then((res) => {
        setDeliveryList(
          res?.data?.map((v) => {
            return { ...v, value: v?.id, price: parseInt(v?.value) };
          })
        );
        tempDelivery = parseInt(res?.data?.[0]?.value);
        setDeliveryChecked({
          ...res?.data?.[0],
          value: tempDelivery,
        });
      });
      await getCartItems(tempDelivery);
    }
    loadPage();
  }, [basketListUpdater]); //shFazeli 1402/04/25

  const [activeStep, setActiveStep] = useState(1);
  const [showOffcanvas, setShowOffcanvas] = useState(false);
  return (
    <CardItemContext.Provider
      value={{
        basketData,
        activeStep,
        showOffcanvas,
        setBasketData,
        setActiveStep,
        setShowOffcanvas,
        giftCode,
        setGiftCode,
        checkGiftCode,
        changeItemCount, //shFazeli 1402/04/25
        itemCount, //shFazeli 1402/04/25
        getItemCountProductPrice, //shFazeli 1402/04/26
        submitOrder, //shFazeli 1402/04/26
        addressId, //kiani 1402/12/23
        setAddressId, //kiani 1402/12/23
        setDescription, //kiani 1402/12/26
        description, //kiani 1402/12/26
        deliveryList,
        deliveryChecked,
        changeDeliveryType,
      }}
    >
      {children}
      <Container
        loginShow={loginShow}
        setLoginShow={setLoginShow}
        changeUserInformation={() => {}}
      />
      {/* shFazeli 1402/04/28 */}
    </CardItemContext.Provider>
  );
};
